import classnames from 'classnames/bind'
import { format, isFuture } from 'date-fns'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import styles from './date_time_picker.module.scss'

const cx = classnames.bind(styles)

export default class DateTimePicker extends Component {
  constructor(props) {
    const isDateString = typeof props.currentDate === 'string'
    const currentDate = isDateString ? `${props.currentDate}`.replace(/-/g, '/') : props.currentDate

    super(props)
    this.state = {
      currentDate: currentDate ? new Date(currentDate) : null
    }
  }

  handleChange(date) {
    const { enabledPastDate } = this.props
    const { currentDate } = this.state

    // NOTE: 明日以降を手入力しようとした場合はstateを更新しない
    this.setState({
      currentDate: enabledPastDate && isFuture(date, currentDate) ? currentDate : date
    })
  }

  render() {
    const {
      className,
      dateFormat,
      datePickerClassName,
      defaultValue,
      enabledPastDate,
      name,
      showTimeSelectOnly,
      timeFormat,
      timeIntervals
    } = this.props
    const { currentDate } = this.state
    const value = showTimeSelectOnly ? format(currentDate, timeFormat) : currentDate

    return (
      <div className={cx(className, styles.wrapper)}>
        <DatePicker
          name={name}
          className={cx(datePickerClassName, styles.formControl)}
          selected={currentDate}
          value={currentDate === null ? defaultValue : value}
          dateFormat={dateFormat}
          showTimeSelect
          showTimeSelectOnly={showTimeSelectOnly}
          timeFormat={timeFormat}
          timeIntervals={timeIntervals}
          minDate={enabledPastDate ? undefined : new Date()}
          maxDate={enabledPastDate ? new Date() : undefined}
          previousMonthButtonLabel=""
          nextMonthButtonLabel=""
          locale="en"
          onChange={date => this.handleChange(date)}
        />
      </div>
    )
  }
}

DateTimePicker.propTypes = {
  className: PropTypes.string,
  dateFormat: PropTypes.string,
  datePickerClassName: PropTypes.string,
  defaultValue: PropTypes.string,
  currentDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  enabledPastDate: PropTypes.bool,
  name: PropTypes.string.isRequired,
  showTimeSelectOnly: PropTypes.bool,
  timeFormat: PropTypes.string,
  timeIntervals: PropTypes.number
}

DateTimePicker.defaultProps = {
  className: null,
  currentDate: null,
  dateFormat: 'yyyy/MM/dd HH:mm',
  datePickerClassName: null,
  defaultValue: null,
  enabledPastDate: true,
  showTimeSelectOnly: false,
  timeFormat: 'HH:mm',
  timeIntervals: 60
}
